import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AttendanceItemViewModel } from 'src/app/models/item.model';
import { SelectAttendanceAlertsEventPayload, SelectStudentEventPayload } from '../../models/event-payloads.model';
import { PublisherAvatarComponent } from '../publisher-avatar/publisher-avatar.component';

@Component({
  selector: 'app-attendance-publisher',
  templateUrl: './attendance-publisher.component.html',
  styleUrls: ['./attendance-publisher.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PublisherAvatarComponent]
})
export class AttendancePublisherComponent {
  @Input() item: AttendanceItemViewModel;
  @Input() showPublisherLink: boolean;
  @Output() selectStudent = new EventEmitter<SelectStudentEventPayload>();
  @Output() selectAttendanceAlerts = new EventEmitter<SelectAttendanceAlertsEventPayload>();

  showAttendanceAlerts(event): void {
    event.stopPropagation();
    this.selectAttendanceAlerts.emit({
      studentId: this.item.student.id,
      schoolId: this.item.schoolId
    });
  }
}
